'use strict';

import $ from 'jquery';

const common = {
  init() {
    $(window).on('keydown', function (event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });
  },
};

const _this = common;

export default _this;
